'use client'

import CTASection from '@/components/CTASection'
import Image from 'next/image'
import insights from '@/images/insights.png'
import savingsPotential from '@/images/savings-potential-v2.png'
import queryOptimization from '@/images/query-optimization-v2.png'
import queryOptimizationInsights from '@/images/query-optimization.png'
import { seanVideoAmp } from '@/components/Testimonials'
import FeaturesHero from '@/components/FeaturesHero'
import FeaturesTestimonial from '@/components/FeaturesTestimonial'
import FeaturesList from '@/components/FeaturesList'

export default function Main() {
  const feature = {
    name: 'insights',
    heading: 'Ensure effective usage of Snowflake resources',
    description:
      "SELECT's intelligent insights engine continuously analyzes your Snowflake account for optimization opportunities.",
    image: insights,
  }

  const primaryFeatures = [
    {
      heading: 'Understand your savings potential',
      description:
        "Quickly see your total potential savings along with the estimated effort for each opportunity. Filter by resource, potential savings or level of effort in order to prioritize your team's work.",
      image: savingsPotential,
    },
  ]

  const secondaryFeatures = [
    {
      heading: 'Query Optimization Insights',
      description:
        "Accelerate query workloads, reduce compute costs, andeducate business users on query best practices with SELECT's query-level insights and analysis.",
      image: queryOptimizationInsights,
    },
  ]

  return (
    <main className="w-full pt-[61.51px] font-sans lg:pt-[73px]">
      <FeaturesHero feature={feature} />
      <FeaturesTestimonial
        review="SELECT has repeatedly surfaced inefficient common query patterns, and has helped us spot 200 TiB of unused tables to drop, resulting in continued significant cost savings.<>SELECT is always adding new features to help their customers better understand and reduce their spending.<>"
        person={seanVideoAmp}
        company="videoAmp"
      />

      <FeaturesList features={primaryFeatures} gradientBg={'bottom'} />

      <section
        className={`relative flex w-full flex-col items-center px-5 py-20 sm:px-10 xl:px-[100px] xl:py-[112px]`}
      >
        <Image
          src={queryOptimization}
          alt={feature.heading}
          className="w-full max-w-[1240px]"
        />
        <div className="flex w-full flex-col items-center gap-40 xl:mt-0 xl:gap-[224px]">
          {secondaryFeatures.map((feature, index) => (
            <div
              key={feature.heading}
              className={`flex ${
                index % 2 === 0
                  ? 'flex-col-reverse xl:flex-row-reverse'
                  : 'flex-col-reverse xl:flex-row'
              } w-full max-w-[1240px] items-center justify-between gap-10 xl:gap-20`}
            >
              <Image
                src={feature.image}
                alt={feature.heading}
                className="w-[580px]"
              />

              <div className="flex w-full flex-col items-start justify-center px-0 xl:w-[580px] xl:px-[60px]">
                <h3 className="mt-4 w-full text-[26px] font-medium leading-[130%] tracking-[-0.26px] lg:w-[497px] xl:text-[36px] xl:tracking-[-0.36px]">
                  {feature.heading}
                </h3>
                <p className="mt-4 w-full text-base leading-[150%] tracking-[-0.16px] text-white/80 lg:w-[457px] xl:mt-5">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <CTASection />
    </main>
  )
}
